<script lang="ts">
  export let size = '2rem'; // custom from sq-custom-accordion-plus-minus-size-h4
  export let thickness = '.4rem'; // custom from sq-custom-accordion-plus-minus-size-h4
  export let color = '--color-blue';
  export let isExpanded = false;
</script>

<span
  class="AccordionPlusMinusPartial"
  class:expanded={isExpanded}
  aria-expanded={isExpanded}
  style:--size={size}
  style:--thickness={thickness}
  style:--color={`var(${color})`}
/>

<style lang="scss">
  .AccordionPlusMinusPartial {
    position: relative;
    width: var(--size);
    height: var(--size);
    min-width: var(--size);
    margin-left: var(--size);

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: var(--size);
      height: var(--thickness);
      background-color: var(--color);
      transition: transform var(--duration-slow) var(--easing-sharp);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(90deg);
    }

    &.expanded {
      &::before {
        transform: translate(-50%, -50%) rotate(-180deg);
      }

      &::after {
        transform: translate(-50%, -50%) rotate(-90deg) scaleX(0);
      }
    }
  }
</style>
